var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClicPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 105,
    viewBox: "0 0 100 105",
    width: 100,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m46 34v37l26-18.4597z",
    fill: "#f8a51b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100 80.3135-21.7668-10.8135c-5.4342 7.2577-14.2534 11.9878-24.1926 11.9878-16.4738 0-29.8757-12.9923-29.8757-28.9624 0-15.9702 13.4019-28.964 29.8757-28.964 9.6356 0 18.2185 4.4458 23.6844 11.3308l21.9516-10.6576c-9.3955-14.1934-25.6402-23.738918-44.175-24.216156-.046-.001537-.0928-.0023055-.1388-.0038425-.3694-.00845351-.7412-.012296-1.113-.013833-.0317 0-.0626-.0007685-.0935-.0007685-29.8622 0-54.1563 23.5514-54.1563 52.5008 0 28.9486 24.2941 52.4992 54.1563 52.4992 8.1168 0 15.8221-1.741 22.7387-4.857l.1887-.086c.2029-.0914.4043-.1852.6049-.2789.3242-.153.646-.3067.9655-.4658.0262-.013.0531-.0269.0793-.0399 8.7272-4.3497 16.0829-10.9311 21.2666-18.9589z",
    fill: "#fff",
    fillOpacity: 0.25
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClicPlay);
export default __webpack_public_path__ + "static/media/clic_play.6c37c8a206a627566d60d69a6f3a9de8.svg";
export { ForwardRef as ReactComponent };